import { render, staticRenderFns } from "./tavernView.vue?vue&type=template&id=7d58a79c&scoped=true"
import script from "./tavernView.vue?vue&type=script&lang=js"
export * from "./tavernView.vue?vue&type=script&lang=js"
import style0 from "./tavernView.vue?vue&type=style&index=0&id=7d58a79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d58a79c",
  null
  
)

export default component.exports